import { render, staticRenderFns } from "./safe-danger.vue?vue&type=template&id=2f3ef194&scoped=true&"
import script from "./safe-danger.vue?vue&type=script&lang=js&"
export * from "./safe-danger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3ef194",
  null
  
)

export default component.exports